import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import ReviewTypeRequestForm from '../../components/testimonials/ReviewTypeRequestForm';

const Request1to1Call: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClose = () => {
    navigate('/1to1-calls');
  };

  return (
    <div className="flex-1 p-8 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">{t('oneToOneCalls.requestPage.title')}</h1>
            <p className="text-gray-600 mt-2">
              {t('oneToOneCalls.requestPage.subtitle')}
            </p>
          </div>
          <button
            onClick={handleClose}
            className="flex items-center space-x-2 px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>{t('oneToOneCalls.buttons.backToCalls')}</span>
          </button>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8">
          <ReviewTypeRequestForm onClose={handleClose} initialType="ONE_ON_ONE" />
        </div>
      </div>
    </div>
  );
};

export default Request1to1Call;
